import React from "react";
import Modal from "../../../components/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import classes from "./ContactConfirm.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import RegularButton from "../../../components/Inputs/Button/RegularButton/RegularButton";
import { hideContactConfirm, showContactForm } from "../../../store/Contact/actions";

type Props = {};

const ContactConfirm: React.FC<Props> = (props) => {
    const contactConfirmIsShowing = useSelector(
        (state: RootState) => state.contactReducer.contactConfirm.isShowing
    );
    const contactEmail = useSelector((state: RootState) => state.contactReducer.contactForm.emailText);

    const dispatch = useDispatch();

    const thanksClickHandler = () => {
        dispatch(hideContactConfirm());
        dispatch(showContactForm());
    };

    return (
        <Modal
            extraClasses={[
                classes.Modal,
                contactConfirmIsShowing ? classes.doNotOffsetContactConfirm : classes.doOffsetContactConfirm
            ].join(" ")}>
            <div className={classes.ContactConfirm}>
                <FontAwesomeIcon icon={faCheckCircle} className={classes.CheckIcon} />
                <div className={classes.ContactConfirmText}>Message sent successfully.</div>
                <div className={classes.ContactConfirmText}>
                    You will receive a confirmation message at{" "}
                    <span className={classes.EmailText}>{contactEmail}</span> in a few seconds. Please,
                    check your email inbox now.
                </div>
                <RegularButton click={thanksClickHandler} extraClasses={classes.ThanksButton}>
                    Thanks
                </RegularButton>
            </div>
        </Modal>
    );
};

export default ContactConfirm;
